import styled from '@emotion/styled';
import Dialog from '@mui/material/Dialog';
import { Constants, useTheme } from '@trinity/chat-components/components/Theme';
import { ChatAgentsEmptyState } from '@trinity/chat-components/containers/ChatContexts/Chat.Agents.EmptyState';
import { Close } from './Close';
import type { ChatModalProps } from './Modal';

// Modal shell for when the application has no chat contexts. ChatModal needs a chat session,
// which can't be built without one, so this renders the same dialog and close control around
// the empty state instead.
// Unlike ChatModal it never goes fullscreen on phones, so the close control stays reachable.
export const ChatEmptyModal = ({ open, onClose, className }: ChatModalProps) => {
  const theme = useTheme();

  return (
    <Dialog
      className={className}
      fullWidth
      maxWidth="sm"
      onClose={onClose}
      sx={{
        zIndex: theme.zIndex.baseModal,
      }}
      PaperProps={{
        sx: {
          overflow: 'inherit !important',
        },
      }}
      open={open}
    >
      <Root>
        <ChatAgentsEmptyState />
        <StyledClose onClick={onClose} />
      </Root>
    </Dialog>
  );
};

const Root = styled.div(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.white.main,
  borderRadius: `${Constants.Modal.BorderRadius}px`,
}));

const closeOffset = -20;

const StyledClose = styled(Close)({
  position: 'absolute',
  right: `${closeOffset}px`,
  top: `${closeOffset}px`,
});
